import { render, staticRenderFns } from "./WelcomeChecklist.vue?vue&type=template&id=bee35b90&lang=pug&"
import script from "./WelcomeChecklist.vue?vue&type=script&lang=js&"
export * from "./WelcomeChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports